import React from 'react';
import { styled } from '@mui/material';
import { Label } from './Label';
import { Text } from './Text';
import { Row } from './Row';

interface FieldGroupProps {
    label: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
    required?: boolean;
    subtext?: string;
    help?: React.ReactNode;
}

export function FieldGroup({ label, children, style, required, subtext, help }: FieldGroupProps) {
    return (
        <Group style={style}>
            <Label>
                <Row gap="sm" align="center">
                    <span>{required ? `${label} *` : label}</span>
                    {help && help}
                </Row>
                {subtext && (
                    <Text size="sm" tone="secondary">
                        {subtext}
                    </Text>
                )}
            </Label>
            {children}
        </Group>
    );
}

const Group = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
});
